import React from "react";
import img12 from "../images/img12.png";
import img13 from "../images/img13.jpg";
import img15 from "../images/img15.png";
import blogging from "../images/blogging.png";
import Materialize from "../images/Materialize.svg";

import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import "./Home.css";
function Home() {
  return (
    <>
      <div className="home">
        {/* home main */}
        <div className="home_main">
          <div className="container grid">
            <div className="home_main_text">
              <h1>Welcome</h1>
              <p>Your Desire ~ My Mission</p>
              <Link to="/contact" className="contact-btn btn btn-primary">
                Contact Me
              </Link>
            </div>
            <img src={img12} alt="sorry" />
          </div>
        </div>
        {/* intro to Dodo */}
        <div className="home_intro">
          <div className="container grid">
            <div className="home_intro_text">
              <h2>About Me </h2>
              <p>
                
               
               <bold>I am a Website Developer and ChatBot Expert</bold>
                <br />
                I have 2 Years of Experience in Front End Developemt. If you have any Design and want to make it real Website Feel Free to Contact Me. I can also design the whole Website From the Scratch. 
                <br />
                You can Check my Work and Projects here
              </p>
              <Link to="/services" className="services-btn btn btn-dark">
                Projects
              </Link>
            </div>
            <img src={img13} alt="sorry" />
          </div>
        </div>

        {/* technologies we work */}

        <div className="home_tech">
          <h2
            className="center"
            style={{ fontSize: "50px", fontWeight: "600" }}
          >
            Technologies we Work On
          </h2>
          <h4
            className="center front"
            style={{ fontSize: "30px", fontWeight: "600" }}
          >
            Frontend Technologies
          </h4>
          <div className="container flex">
            <div className="card">
              <h4 style={{ textAlign: "center" }}>HTML</h4>
              <i
                class="fab fa-html5 fa-6x html-icon"
                style={{ textAlign: "center" }}
              ></i>
            </div>
            <div className="card">
              <h4 style={{ textAlign: "center" }}>CSS</h4>
              <i class="fab fa-css3-alt fa-6x css-icon"></i>
            </div>
            <div className="card">
              <h4 style={{ textAlign: "center" }}>JavaScript</h4>
              <i class="fab fa-js fa-6x js-icon"></i>
            </div>
            <div className="card">
              <h4 style={{ textAlign: "center" }}>React</h4>
              <i class="fab fa-react fa-6x react-icon"></i>
            </div>
          </div>
          <h3
            className="center front"
            style={{ fontSize: "25px", fontWeight: "600" }}
          >
         CSS   Framworks
          </h3>
          <div className="container flex">
            <div className="card">
              <h4 style={{ textAlign: "center" }}>Bootstrap</h4>
              <i class="fa-brands fa-4x fa-bootstrap text-center"></i>            </div>
            <div className="card">
              <h4 style={{ textAlign: "center", padding: "5px" }}>Materialize CSS</h4>
              <img src="https://iconape.com/wp-content/files/zg/371252/svg/371252.svg" width={50} height={50}/>           

                </div>
            <div className="card">
              <h4 style={{ textAlign: "center" }}>Tailwind CSS</h4>
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/2048px-Tailwind_CSS_Logo.svg.png" width={100} height={130}/>           
            </div>
            <br />
            
          </div>
          {/* <div className="container flex">
         
           <div className="card">
              <h4 style={{ textAlign: "center" }}>Bulma CSS</h4>
              <img src="https://iconape.com/wp-content/files/df/370667/svg/bulma-logo-icon-png-svg.png" width={100} height={130}/>           
            </div>
            <br />
            
          </div> */}
          

        </div>
        {/* work environment */}
        <div className="work-env">
          <div className="container">
            <img src={blogging} alt="sorry" />
          </div>
        </div>
      </div>
     
    </>
  );
}
export default Home;
